// extracted by mini-css-extract-plugin
export default {"Container":"RzmvQF1OeeGwW_ILlpMI","Logo":"gNrtAT4l_9ryNVA_wLQc"};